module.exports = __webpack_public_path__ + "static/media/0_2018_10_05.1c3f936f.jpeg";